import * as React from "react";

export const SvgDelete = (props) => (
	<svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16.456 5a.625.625 0 0 0-.625-.625H4.164A.625.625 0 0 0 3.54 5v11.25a2.706 2.706 0 0 0 2.708 2.708h7.5a2.706 2.706 0 0 0 2.709-2.708V5Zm-1.25.625V16.25c0 .387-.154.758-.428 1.03a1.455 1.455 0 0 1-1.03.428h-7.5A1.455 1.455 0 0 1 4.79 16.25V5.625h10.416Z"
			fill={props.color ?? "#A8A8A8"}
			stroke={props.color ?? "#A8A8A8"}
			strokeWidth={0.3}
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M13.75 5.625c.345 0 .625-.28.625-.625V3.334c0-.608-.242-1.191-.67-1.621a2.296 2.296 0 0 0-1.622-.671H7.917c-.608 0-1.191.242-1.621.67-.43.43-.671 1.014-.671 1.622V5c0 .345.28.625.625.625h7.5Zm-.625-1.25h-6.25V3.334a1.043 1.043 0 0 1 1.042-1.042h4.166a1.043 1.043 0 0 1 1.042 1.042v1.041Z"
			fill={props.color ?? "#A8A8A8"}
			stroke={props.color ?? "#A8A8A8"}
			strokeWidth={0.3}
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16.665 4.375H3.332a.625.625 0 0 0 0 1.25h13.333a.625.625 0 0 0 0-1.25ZM7.29 8.75v5.833a.625.625 0 0 0 1.25 0V8.75a.625.625 0 0 0-1.25 0ZM11.457 8.75v5.833a.625.625 0 0 0 1.25 0V8.75a.625.625 0 0 0-1.25 0Z"
			fill={props.color ?? "#A8A8A8"}
			stroke={props.color ?? "#A8A8A8"}
			strokeWidth={0.3}
		/>
	</svg>
);
